import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const { t } = useTranslation('common');

  return (
    <section id="services" className="py-14 md:py-24 bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-light text-gray-900 mb-2 md:mb-3">{t('services.title')}</h2>
          <p className="text-lg md:text-2xl text-stone-500 font-light mb-3 md:mb-4">{t('services.subtitle')}</p>
          <p className="text-sm text-gray-600">{t('')}</p>
        </div>

        {/* Mobile: single column / Desktop: Row 1 grid */}
        <div className="flex flex-col gap-5 md:grid md:grid-cols-3 md:gap-8 mb-5 md:mb-8">
          {/* PELLOWAH - Featured */}
          <div className="bg-teal-800 rounded-2xl md:rounded-3xl p-7 md:p-10 text-white space-y-4 md:space-y-5 hover:scale-[1.02] transition-transform cursor-pointer">
            <div>
              <h3 className="text-2xl md:text-3xl font-medium mb-1">{t('services.pellowah.title')}</h3>
              <p className="text-sm text-white/70">{t('services.pellowah.subtitle')}</p>
            </div>
            <div className="w-full aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/74789cb4689f6ca804e77800faff7969.jpg"
                alt="PELLOWAH"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-sm leading-relaxed text-white/90">{t('services.pellowah.description')}</p>
            <Link to="/services/pellowah">
              <button className="w-full py-3 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-medium hover:bg-amber-400 hover:text-teal-900 transition-all whitespace-nowrap cursor-pointer">
                {t('services.pellowah.button')}
              </button>
            </Link>
          </div>

          {/* UMANA */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-7 md:p-8 space-y-4 hover:scale-[1.02] transition-transform cursor-pointer relative flex flex-col md:col-span-1">
            <div className="absolute top-5 left-5 md:top-6 md:left-6 px-3 py-1 bg-amber-400 text-teal-900 rounded-full text-xs font-medium whitespace-nowrap">
              {t('services.umana.tag')}
            </div>
            <div className="pt-8">
              <h3 className="text-xl md:text-2xl font-medium text-gray-900 mb-1">{t('services.umana.title')}</h3>
              <p className="text-sm text-stone-500">{t('services.umana.subtitle')}</p>
            </div>
            <div className="w-full rounded-2xl overflow-hidden" style={{ height: '180px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Holistic%20body%20mind%20spirit%20integration%20healing%20session%20with%20a%20serene%20person%20surrounded%20by%20soft%20glowing%20energy%20field%2C%20gentle%20waves%20of%20light%20in%20warm%20neutral%20tones%2C%20peaceful%20minimalist%20zen%20space%20with%20natural%20elements%2C%20plants%20and%20soft%20candlelight%20creating%20a%20deeply%20calming%20and%20restorative%20atmosphere%20for%20deep%20emotional%20healing&width=500&height=360&seq=service-umana-001&orientation=landscape"
                alt="UMANA"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-sm leading-relaxed text-gray-700 flex-1">{t('services.umana.description')}</p>
            <Link to="/services/umana">
              <button className="w-full py-3 bg-teal-800 text-white rounded-full text-sm font-medium hover:bg-teal-900 transition-all whitespace-nowrap cursor-pointer">
                {t('services.umana.button')}
              </button>
            </Link>
          </div>

          {/* 巴赫花精疗愈 */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-7 md:p-8 space-y-4 hover:scale-[1.02] transition-transform cursor-pointer relative flex flex-col md:col-span-1">
            <div className="absolute top-5 left-5 md:top-6 md:left-6 px-3 py-1 bg-stone-400 text-white rounded-full text-xs font-medium whitespace-nowrap">
              {t('services.bach.tag')}
            </div>
            <div className="pt-8">
              <h3 className="text-xl md:text-2xl font-medium text-gray-900 mb-1">{t('services.bach.title')}</h3>
              <p className="text-sm text-stone-500">{t('services.bach.subtitle')}</p>
            </div>
            <div className="w-full rounded-2xl overflow-hidden" style={{ height: '180px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20Bach%20flower%20remedies%20collection%20with%20delicate%20wildflowers%20in%20soft%20morning%20light%2C%20small%20glass%20dropper%20bottles%20with%20golden%20liquid%20arranged%20among%20fresh%20blooming%20flowers%20on%20a%20white%20linen%20surface%2C%20gentle%20pastel%20tones%20of%20pink%20lavender%20and%20cream%20creating%20a%20tender%20and%20healing%20botanical%20atmosphere&width=500&height=360&seq=service-bach-001&orientation=landscape"
                alt="Bach Flower Remedies"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-sm leading-relaxed text-gray-700 flex-1">{t('services.bach.description')}</p>
            <Link to="/services/bach">
              <button className="w-full py-3 bg-teal-800 text-white rounded-full text-sm font-medium hover:bg-teal-900 transition-all whitespace-nowrap cursor-pointer">
                {t('services.bach.button')}
              </button>
            </Link>
          </div>
        </div>

        {/* Row 2: 量子催眠 + 神谕卡 + 脉轮测试 */}
        <div className="flex flex-col gap-5 md:grid md:grid-cols-3 md:gap-8">
          {/* 量子催眠 */}
          <div className="bg-amber-50 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col gap-4 hover:scale-[1.02] transition-transform cursor-pointer relative">
            <div className="absolute top-4 left-4 md:top-6 md:left-6 px-3 py-1 bg-teal-700 text-white rounded-full text-xs font-medium whitespace-nowrap">
              {t('services.quantum.tag')}
            </div>
            <div className="w-full rounded-2xl overflow-hidden mt-6" style={{ height: '160px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Deep%20quantum%20hypnosis%20meditation%20scene%20with%20a%20person%20in%20profound%20relaxation%20surrounded%20by%20swirling%20cosmic%20energy%20and%20soft%20glowing%20light%20tunnels%2C%20ethereal%20past%20life%20visions%20and%20subconscious%20mind%20exploration%20with%20gentle%20blue%20gold%20and%20white%20light%20rays%20in%20a%20peaceful%20dreamlike%20spiritual%20atmosphere&width=400&height=400&seq=service-quantum-001&orientation=squarish"
                alt="Quantum Hypnosis"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-medium text-gray-900 mb-1">{t('services.quantum.title')}</h3>
              <p className="text-xs text-stone-500 mb-2">{t('services.quantum.subtitle')}</p>
              <p className="text-xs md:text-sm leading-relaxed text-gray-700">{t('services.quantum.description')}</p>
            </div>
            <Link to="/services/quantum">
              <button className="w-full py-2.5 md:py-3 bg-teal-800 text-white rounded-full text-sm font-medium hover:bg-teal-900 transition-all whitespace-nowrap cursor-pointer">
                {t('services.quantum.button')}
              </button>
            </Link>
          </div>

          {/* 神谕卡 */}
          <div className="bg-stone-800 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col gap-4 hover:scale-[1.02] transition-transform cursor-pointer relative">
            <div className="absolute top-4 left-4 md:top-6 md:left-6 px-3 py-1 bg-amber-400 text-stone-900 rounded-full text-xs font-medium whitespace-nowrap">
              {t('services.oracle.tag')}
            </div>
            <div className="w-full rounded-2xl overflow-hidden mt-6" style={{ height: '160px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Mystical%20oracle%20card%20reading%20spread%20with%20beautifully%20illustrated%20divine%20guidance%20cards%20featuring%20celestial%20symbols%20moon%20stars%20and%20sacred%20imagery%20arranged%20on%20dark%20velvet%20cloth%2C%20surrounded%20by%20glowing%20candles%20crystals%20and%20dried%20flowers%20with%20warm%20golden%20candlelight%20creating%20an%20enchanting%20and%20intuitive%20spiritual%20atmosphere&width=400&height=400&seq=service-oracle-001&orientation=squarish"
                alt="Oracle Card Reading"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-medium text-white mb-1">{t('services.oracle.title')}</h3>
              <p className="text-xs text-stone-400 mb-2">{t('services.oracle.subtitle')}</p>
              <p className="text-xs md:text-sm leading-relaxed text-stone-300">{t('services.oracle.description')}</p>
            </div>
            <Link to="/services/oracle">
              <button className="w-full py-2.5 md:py-3 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-medium hover:bg-amber-400 hover:text-stone-900 transition-all whitespace-nowrap cursor-pointer">
                {t('services.oracle.button')}
              </button>
            </Link>
          </div>

          {/* 脉轮测试 */}
          <div className="bg-rose-50 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col gap-4 hover:scale-[1.02] transition-transform cursor-pointer relative">
            <div className="absolute top-4 left-4 md:top-6 md:left-6 px-3 py-1 bg-rose-400 text-white rounded-full text-xs font-medium whitespace-nowrap">
              {t('services.chakra.tag')}
            </div>
            <div className="w-full rounded-2xl overflow-hidden mt-6" style={{ height: '160px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=seven%20colorful%20chakra%20energy%20centers%20shown%20as%20glowing%20spheres%20of%20light%20arranged%20vertically%20from%20red%20to%20violet%2C%20sacred%20rainbow%20energy%20points%20floating%20in%20soft%20ethereal%20space%20with%20golden%20particles%20and%20gentle%20misty%20light%2C%20spiritual%20energy%20assessment%20visualization%20with%20warm%20natural%20tones%20and%20serene%20meditative%20atmosphere&width=400&height=400&seq=service-chakra-card-001&orientation=squarish"
                alt="Chakra Assessment"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-medium text-stone-800 mb-1">{t('services.chakra.title')}</h3>
              <p className="text-xs text-stone-500 mb-2">{t('services.chakra.subtitle')}</p>
              <p className="text-xs md:text-sm leading-relaxed text-stone-600">{t('services.chakra.description')}</p>
            </div>
            <Link to="/services/chakra">
              <button className="w-full py-2.5 md:py-3 bg-rose-500 text-white rounded-full text-sm font-medium hover:bg-rose-600 transition-all whitespace-nowrap cursor-pointer">
                {t('services.chakra.button')}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
